// ЛК: загрузка аватара на сервер
function ajaxProfileUploadAvatar() {
	var formData = new FormData(),
		csrfmiddlewaretoken = getCookie('csrftoken'),
		file = $('input[type=file][name="avatar_file"]')[0].files[0];

	formData.append('csrfmiddlewaretoken', csrfmiddlewaretoken);
	formData.append('avatar_file', file);

	$.ajax({
		data: formData,
		url: '/profile/upload-avatar/',
		method: "POST",
		processData: false, // Обязательный параметр для отправки FormData
		contentType: false, // Обязательный параметр для отправки FormData
		cache: false,

		xhr: function() {
			var xhrRequest = $.ajaxSettings.xhr();

			if (xhrRequest.upload) {
				xhrRequest.upload.addEventListener('progress', function(event) {
					if (event.lengthComputable) { // Проверка, отдает ли сервер состояние
						var max = event.total,
							current = event.loaded,
							canvas = $('.avatar-upload-indicator')[0],
							context = canvas.getContext('2d');

						context.clearRect(0, 0, canvas.width, canvas.height);
						context.beginPath();
						context.lineWidth = 2;
						context.strokeStyle = "#ec584c";
						context.arc(90, 90, 88, - .5 * Math.PI, (current / max) * 2 * Math.PI - .5 * Math.PI);
						context.stroke();
					}
				}, false);
			}

			return xhrRequest;
		},

		beforeSend: function() {
			$('.avatar-border-container').addClass('upload-photo');
			$('.avatar-upload-indicator').addClass('active');
			$('.avatar').data('src', $('.avatar').attr('src'));
			$('.avatar').attr('src', emptyImage);
		},

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				$('.avatar').attr('src', responseObj.result.json.url);
				$('.avatar-border-container').removeClass('upload-photo').addClass('with-photo');
				$('.avatar-upload-indicator').removeClass('active');
				$('input[name="avatar"]').val(responseObj.result.json.id);
				showNotification(responseObj.result.message, 'success');
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		},

		error: function() {
			var oldSrc = $('.avatar').data('src');

			if (oldSrc) {
				$('.avatar').attr('src', $('.avatar').data('src'));
				$('.avatar-border-container').addClass('with-photo');
			}
			
			$('.avatar-border-container').removeClass('upload-photo')
			$('.avatar-upload-indicator').removeClass('active');
			showNotification('Ошибка сервера, попробуйте повторить попытку позже', 'error');
		}
	});
}


// ЛК: редактирование персональной информации пользователя
function ajaxProfileUserEdit(jqForm) {
	var dataToSend = 'action=user_edit&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				showNotification(responseObj.result.message, 'success');
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// ЛК: смена пароля
function ajaxProfileChangePassword(jqForm) {
	var dataToSend = 'action=change_password&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				hidePopUps();
				setNotificationCookie(responseObj.result.message, 'success');
				location.reload();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// ЛК: изменение номера телефона
function ajaxProfileChangePhone(jqForm) {
	var dataToSend = 'action=change_phone&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				var phone = jqForm.find('input[name="phone"]').val(),
					form = $('form.confirm-code');

				phone = phone.substr(0, 9) + '*** ** ' + phone.substr(-2);
				
				form.find('.get-confirm-code-button, .submit-form').data('action', 'change-phone');
				$('.body-cover-pop-up-wrapper.confirm-code .code-description span').html(phone);
				showPopUp('confirm-code');
				startConfirmCodeTimer();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// ЛК: отправка кода подтверждения при изменении телефона
function ajaxProfileSendConfirmCode(jqForm) {
	var dataToSend = 'action=send_confirm_code&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				hidePopUps();
				setNotificationCookie(responseObj.result.message, 'success');
				location.reload();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// ЛК: отправка повторного запроса на получение кода при изменении телефона
function ajaxProfileGetConfirmCode(jqForm) {
	var dataToSend = 'action=get_confirm_code&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				showNotification(responseObj.result.message, 'success');
				startConfirmCodeTimer();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// ЛК: добавление нового ученика
function ajaxProfileAddLearner(jqForm) {
	var dataToSend = 'action=learner_add&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			console.log(responseObj);

			if (responseObj.status == true) {
				hidePopUps();
				setNotificationCookie(responseObj.result.message, 'success');
				location.reload();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// ЛК: редактирование данных ученика
function ajaxProfileEditLearner(jqForm) {
	var dataToSend = 'action=learner_edit&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				var id = jqForm.find('input[name="learner_id"]').val(),
					container = $('.learner-container[data-learner-id="' + id + '"]');

				container.find('.last-name').html(jqForm.find('input[name="last_name"]').val());
				container.find('.first-name').html(jqForm.find('input[name="first_name"]').val());

				hidePopUps();
				showNotification(responseObj.result.message, 'success');
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// ЛК: удаление ученика
function ajaxProfileDeleteLearner(learnerId) {
	var csrfmiddlewaretoken = getCookie('csrftoken'),
		dataToSend = 'csrfmiddlewaretoken=' + csrfmiddlewaretoken + '&action=learner_delete&learner_id=' + learnerId;

	// console.log(dataToSend);
	
	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				setNotificationCookie(responseObj.result.message, 'success');
				location.reload();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}